module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0125.jpg?v=7d59b9d9";